const Kategoriya2122 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 1-chorak<br />
                Mavzu: Harf birikmasi bilan ifodalangan undoshlar <br />
“Oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Quyida berilgan so‘zlardagi nuqtalar o‘rniga sh, ch, ng harf birikmalaridan mosini qo‘yib yozing.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning imloviy savodxonligini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            <p>Ko‘ndala…, suyan…, …amol, …iroq, to…, bo…, bo…la, ta…lamoq.</p>
            <p><b>2-mashq. Juftlikda ishlang. Tez aytishdagi nuqtalar o‘rniga mos undoshni qo‘ying va tez aytishga tayyorlaning.</b></p>
            <p>U…tamiz u… ustamiz,</p>
            <p>U……alamiz ustamiz.</p>
            <p><b>3-mashq. Gapni mazmunan davom ettiring.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning gap tuzish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Bola – hayot ______________.</p>
            <p>Salomatlik – tuman ___________.</p>
        </div>
    )
}
export default Kategoriya2122;